export const items = [
  {
    id: 1,
    link: "#home",
    name: "home",
  },
  {
    id: 2,
    link: "#about",
    name: "about",
  },
  {
    id: 3,
    link: "#skills",
    name: "skills",
  },
  {
    id: 4,
    link: "#work",
    name: "work",
  },
  {
    id: 5,
    link: "#contact",
    name: "contact",
  },
];
